import { call, put, select, takeLatest } from "redux-saga/effects";

import {
  getNotificationsInfo,
  getNotificationsInfoFailure,
  getItemsNotificationsCard,
  getItemsNotificationsCardFailure,
} from "../actions";
import { getItemsSuccess } from "src/modules/spItems/actions";
import { PayloadAction } from "@reduxjs/toolkit";
import { ListFieldsKeys, ListFieldsRecordType } from "src/api/config";
import { CurrentUserType } from "src/modules/users/types";
import moment from "moment";
import { TableBodyGetNotificationItem } from "src/components/tables/notificationTables/GetNotificationTable";
import { TableBodySendNotificationItem } from "src/components/tables/notificationTables/SendNotificationTable";
import { getItemsRequest } from "src/modules/spItems/api";
import {
  getNotificationsListName,
  notificationsListName,
  sendNotificationsListName,
  notificationsCardListName,
} from "src/api/config/notifications.config";
import { nameFromEmail, prefix, removePrefix, shortNameFromEmail } from "src/utils/users.utils";
import { selectCurrentUser } from "src/modules/users/selector";
import { notificationStatuses } from "src/api/config/systemSwitch";

export function getTransformDataByActiveNotify(data: ListFieldsRecordType[typeof notificationsListName][]) {
  let getTransformedData: TableBodyGetNotificationItem[] = [];

  try {
    if (data.length > 0) {
      for (const currentNotification of data) {
        const newObj = {
          ID: currentNotification.ID,
          NotificationID: currentNotification.NotificationID ? +currentNotification.NotificationID.get_lookupId() : 0,
          NotificationType: {
            Title: currentNotification.NotificationType.get_lookupValue(),
            ID: +currentNotification.NotificationType.get_lookupId(),
            Metadata: currentNotification.NotificationType?.get_metadata?.() || null,
          },
          Document: {
            Name: !!currentNotification.VersionDocument
              ? currentNotification.VersionDocument.get_lookupValue()
              : currentNotification.Document.get_lookupValue(),
            ID: +currentNotification.Document.get_lookupId(),
            Code: currentNotification.DocumentCode,
          },
          SendDate: moment(currentNotification.Created).locale("ru").format("DD.MM.YYYY"),
          Author: {
            User: {
              Title: nameFromEmail(currentNotification.AuthorEmail),
              Name: nameFromEmail(currentNotification.AuthorEmail),
              Email: currentNotification.AuthorEmail.toLowerCase(),
              ID: +currentNotification.Author.get_lookupId(), // если что исправить
              Avatar: null,
              TitleRus: nameFromEmail(currentNotification.AuthorEmail),
              JobTitle: "",
              JobTitleRus: "",
              Metadata: currentNotification.Author?.get_metadata?.() || null,
            },
            Comment: currentNotification.AuthorComment,
          },
          VersionDocument: currentNotification.VersionDocument,
          Test: !!currentNotification.Test ? +currentNotification.Test.get_lookupId() : null,
          TestAnswerRate: currentNotification.TestAnswerRate,
          TestedEmployee: !!currentNotification.TestedEmployee
            ? currentNotification.TestedEmployee.toLowerCase()
            : null,
          ReviewDate: {
            date: moment(currentNotification.ReviewDate).locale("ru").format("DD.MM.YYYY"),
            expired: moment(currentNotification.ReviewDate).isBefore(new Date()),
          },
          Completed: currentNotification.Completed,
          Employee: {
            Title: nameFromEmail(currentNotification.EmployeeEmail),
            Name: nameFromEmail(currentNotification.EmployeeEmail),
            Email: currentNotification.EmployeeEmail.toLowerCase(),
            ID: +currentNotification.Employee?.get_lookupId() || 0,
            Avatar: null,
            TitleRus: nameFromEmail(currentNotification.EmployeeEmail),
            JobTitle: "",
            JobTitleRus: "",
            Metadata: currentNotification.Employee?.get_metadata?.() || null,
          },
          CheckListID: currentNotification.CheckListID,
          TemplateID: currentNotification.TemplateOWDID,
        };

        getTransformedData.push(newObj);
      }
    }
  } catch (error) {
    console.error("getTransformDataByActiveNotify => versionDocument", error);
  }
  return getTransformedData;
}

export function sendTransformDataByActiveNotify(data: ListFieldsRecordType[typeof notificationsListName][]) {
  let sendTransformedData: TableBodySendNotificationItem[] = [];

  if (data.length > 0) {
    let acc = new Map();

    for (const cur of data) {
      if (cur.NotificationID) {
        if (acc.has(+cur.NotificationID.get_lookupId())) {
          const r = acc.get(+cur.NotificationID.get_lookupId());

          r.Documents.set(cur.DocumentCode, {
            Title: cur.Document.get_lookupValue(),
            ID: +cur.Document.get_lookupId(),
            Code: cur.DocumentCode,
          });

          let emp = r.Employees.get(cur.EmployeeEmail.toLowerCase());
          let readCount = emp?.readCount || 0;
          let readTotalCount = cur.Read ? readCount + 1 : readCount;

          let employeeObj = {
            name: nameFromEmail(cur.EmployeeEmail),
            id: +cur.Employee?.get_lookupId() || 0, // если что исправить
            avatar: null,
            shortName: shortNameFromEmail(cur.EmployeeEmail),
            listId: cur.ID,
            email: cur.EmployeeEmail,
            status: r.Documents.size === readTotalCount ? "success" : "pending",
            readCount: readTotalCount,
          };

          r.Employees.set(cur.EmployeeEmail.toLowerCase(), employeeObj);
        } else {
          const newObj = {
            ID: +cur.NotificationID.get_lookupId(),
            NotificationType: {
              Title: cur.NotificationType.get_lookupValue(),
              ID: +cur.NotificationType.get_lookupId(),
            },
            Author: {
              Title: nameFromEmail(cur.AuthorEmail),
              Name: nameFromEmail(cur.AuthorEmail),
              Email: cur.AuthorEmail.toLowerCase(),
              ID: +cur.Author.get_lookupId(), // если что исправить
              Avatar: null,
            },
            VersionDocument: cur.VersionDocument,
            Test: !!cur.Test ? +cur.Test.get_lookupId() : null,
            TestAnswerRate: cur.TestAnswerRate,
            AuthorComment: cur.AuthorComment,
            NotificationID: +cur.NotificationID.get_lookupId(),
            SendDate: moment(cur.Created).locale("ru").format("DD.MM.YYYY"),
            ReviewDate: {
              date: moment(cur.ReviewDate).locale("ru").format("DD.MM.YYYY"),
              expired: moment(cur.ReviewDate).isBefore(new Date()),
            },
            Documents: new Map([
              [
                cur.DocumentCode,
                { Title: cur.Document.get_lookupValue(), ID: +cur.Document.get_lookupId(), Code: cur.DocumentCode },
              ],
            ]),
            Employees: new Map([
              [
                cur.EmployeeEmail.toLowerCase(),
                {
                  name: nameFromEmail(cur.EmployeeEmail),
                  id: +cur.Employee?.get_lookupId() || 0,
                  avatar: null,
                  shortName: shortNameFromEmail(cur.EmployeeEmail),
                  listId: cur.ID,
                  email: cur.EmployeeEmail,
                  status: cur.Read ? "success" : "pending",
                  readCount: cur.Read ? 1 : 0,
                  lastNotificationDate: moment(cur.Created).valueOf(), // Сохраняем дату
                },
              ],
            ]),
          };

          acc.set(+cur.NotificationID.get_lookupId(), newObj);
        }
      }
    }

    sendTransformedData = [...acc.values()];
  }

  return sendTransformedData;
}

function filterNotificationsByTitle(
  data: ListFieldsRecordType[typeof notificationsListName][],
  title: string = "Отклонено",
) {
  return data.filter((item) => !item.Title.includes(title));
}
function* getNotificationsSaga(action: PayloadAction<{ activeNotifyList: "get" | "send"; listName: ListFieldsKeys }>) {
  try {
    const response: CurrentUserType = yield select(selectCurrentUser);

    const Email = response.email || removePrefix(response.accountName, prefix);

    // if (action.payload.activeNotifyList === "send") {
    const sendData: { items: any[] } = yield call<any>(getItemsRequest, {
      listName: action.payload.listName,
      filters: {
        AuthorEmail: Email.toLowerCase() + "*",
        Hide: false,
        NotificationType: [
          notificationStatuses.acquainted,
          notificationStatuses.getOWD,
          notificationStatuses.acquaintedTest,
          notificationStatuses.familiarization,
          notificationStatuses.OWD,
        ],
      },
      sortOrder: { name: "Created", desc: true },
    });

    const filteredSendData = filterNotificationsByTitle(sendData.items);

    yield put(
      getItemsSuccess({
        listName: sendNotificationsListName,
        items: filteredSendData,
        count: filteredSendData.length,
        merge: false,
        nextPage: null,
        update: false,
      }),
    );
    // } else {
    const getData: { items: any[] } = yield call<any>(getItemsRequest, {
      listName: action.payload.listName,
      filters: {
        EmployeeEmail: Email.toLowerCase() + "*",
        Read: false,
        Hide: false,
        NotificationType: [
          notificationStatuses.acquainted,
          notificationStatuses.getOWD,
          notificationStatuses.approval,
          notificationStatuses.acquaintedTest,
          notificationStatuses.familiarization,
          notificationStatuses.OWD,
        ],
      },
      sortOrder: { name: "Created", desc: true },
    });

    const filteredGetData = filterNotificationsByTitle(getData.items);

    yield put(
      getItemsSuccess({
        listName: getNotificationsListName,
        items: filteredGetData,
        count: filteredGetData.length,
        merge: false,
        nextPage: null,
        update: false,
      }),
    );
    // }
  } catch (error) {
    yield put(getNotificationsInfoFailure(error));
  }
}

function* getNotificationsCardSaga(action: any) {
  try {
    const getData: { items: any[]; count: number } = yield call<any>(getItemsRequest, {
      listName: action.payload.listName,
      filters: action.payload.filters,
      sortOrder: { name: "Created", desc: true },
    });
    yield put(
      getItemsSuccess({
        listName: notificationsCardListName,
        items: getData.items,
        count: getData.count,
        merge: false,
        nextPage: null,
        update: false,
      }),
    );
  } catch (error) {
    yield put(getItemsNotificationsCardFailure(error));
  }
}

export function* notificationsInfoWatcher() {
  yield takeLatest(getNotificationsInfo.toString(), getNotificationsSaga);
  yield takeLatest(getItemsNotificationsCard.toString(), getNotificationsCardSaga);
}
